import { render, staticRenderFns } from "./MbInputSelect2.vue?vue&type=template&id=77675cd7&"
import script from "./MbInputSelect2.vue?vue&type=script&lang=js&"
export * from "./MbInputSelect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports